var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTapHand = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#021135",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.063 27.85S2.775 13.963 5.246 11.925c0 0 1.764-1.853 3.35 1.11l1.76 3.519V2.48S10.531.628 12.648.628c1.022.118 1.829.965 1.941 2.039v9.815s.177-2.782 2.112-2.41c1.324.255 1.41 2.41 1.41 2.41s.177-2.224 1.764-2.038c1.789.207 1.764 2.219 1.764 2.219s.657-1.678 2.117-1.296c.702.186 1.233.93 1.233 2.782 0 0 .354 9.258-3.537 13.515z"
  })));
};
export default SvgTapHand;